import * as React from 'react';
import { SVGProps } from 'react';

const IconTreeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 4a2 2 0 1 1 2.5 1.937V7.5h3.563a2 2 0 1 1 0 1H5.5V11a.5.5 0 0 0 .5.5h3.063a2 2 0 1 1 0 1H6A1.5 1.5 0 0 1 4.5 11V5.937A2 2 0 0 1 3 4Zm8 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
    />
  </svg>
);
export default IconTreeSizeS;
